(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"] && !Shopify.designMode) return;
  try {
    
// Header functionality - cart is handled in shopify-cart.js

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
// Product Description Toggle
document.addEventListener('DOMContentLoaded', function() {
  const descriptionToggle = document.querySelector('.js-toggle-description');
  const descriptionContainer = document.querySelector('.es-description-toggle');
  const sizingChart = document.querySelector('.es-sizing-chart-container');
  const sizingChartOpenButtons = document.querySelectorAll('.es-sizing-chart-toggle .js-toggle-sizing-chart');
  const sizingChartCloseButton = document.querySelector('.es-sizing-chart-close.js-toggle-sizing-chart');

  if (descriptionToggle && descriptionContainer) {
    descriptionToggle.addEventListener('click', function() {
      descriptionContainer.classList.toggle('es-description-toggle--open');
    });
  }

  if (sizingChart && sizingChartOpenButtons.length) {
    sizingChartOpenButtons.forEach((button) => {
      button.addEventListener('click', function(event) {
        event.preventDefault();
        event.stopPropagation();
        sizingChart.classList.add('es-sizing-chart-container--open');
        document.body.classList.add('es-page--sizing-open');
      });
    });
  }

  if (sizingChart && sizingChartCloseButton) {
    sizingChartCloseButton.addEventListener('click', function(event) {
      event.preventDefault();
      event.stopPropagation();
      sizingChart.classList.remove('es-sizing-chart-container--open');
      document.body.classList.remove('es-page--sizing-open');
    });
  }

  if (sizingChart) {
    sizingChart.addEventListener('click', function(event) {
      if (event.target === sizingChart) {
        sizingChart.classList.remove('es-sizing-chart-container--open');
        document.body.classList.remove('es-page--sizing-open');
      }
    });
  }

});

// Army carousel logic
const armyWrapper = document.querySelector('.es-army-carousel-wrapper');
const armyContainer = armyWrapper?.querySelector('.es-army-container-inner');
const leftArrow = armyWrapper?.querySelector('.army-arrow--left');
const rightArrow = armyWrapper?.querySelector('.army-arrow--right');
const armyItems = armyContainer ? armyContainer.querySelectorAll('.es-character--1') : [];
const visible = 5;
let armyIndex = 0;

function updateArmyCarousel() {
  if (!armyContainer || armyItems.length === 0) return;
  const itemWidth = armyItems[0].offsetWidth;
  armyContainer.style.transform = `translateX(-${armyIndex * itemWidth}px)`;
  // Disable arrows at edges
  if (leftArrow) leftArrow.disabled = armyIndex === 0;
  if (rightArrow) rightArrow.disabled = armyIndex >= armyItems.length - visible;
}

if (leftArrow) {
  leftArrow.addEventListener('click', function() {
    if (armyIndex > 0) {
      armyIndex--;
      updateArmyCarousel();
    }
  });
}
if (rightArrow) {
  rightArrow.addEventListener('click', function() {
    if (armyIndex < armyItems.length - visible) {
      armyIndex++;
      updateArmyCarousel();
    }
  });
}
window.addEventListener('resize', updateArmyCarousel);
updateArmyCarousel();

function initializeProductViewer() {
  const modal = document.getElementById('myModal');
  const allPhotosBtn = document.getElementById('allPhotosBtn');
  const openButtons = document.querySelectorAll('.js-open-product-viewer');
  const modalContent = modal ? modal.querySelector('.modal-content') : null;
  const modalStage = modal ? modal.querySelector('.js-modal-stage') : null;
  const closeBtn = modal ? modal.querySelector('.close') : null;
  const prevArrow = modal ? modal.querySelector('#prevArrow') : null;
  const nextArrow = modal ? modal.querySelector('#nextArrow') : null;
  const slides = modal ? Array.from(modal.querySelectorAll('.slider-kartinka')) : [];
  const thumbs = modal ? Array.from(modal.querySelectorAll('.modal-thumb')) : [];
  const frames = modal ? Array.from(modal.querySelectorAll('.js-modal-image-frame')) : [];

  if (!modal || !modalContent || !modalStage || !closeBtn || !prevArrow || !nextArrow || slides.length === 0) return;

  let currentIndex = 0;
  let scale = 1;
  let translateX = 0;
  let translateY = 0;
  let pointerStartX = 0;
  let pointerStartY = 0;
  let lastTranslateX = 0;
  let lastTranslateY = 0;
  let isDragging = false;
  let activeDragFrame = null;
  let swipeStartX = 0;
  let swipeStartY = 0;
  let pinchDistance = 0;
  let pinchScaleStart = 1;
  let touchPanStartX = 0;
  let touchPanStartY = 0;
  let touchPanBaseX = 0;
  let touchPanBaseY = 0;
  let isTouchPanning = false;

  function getActiveFrame() {
    return slides[currentIndex]?.querySelector('.js-modal-image-frame');
  }

  function getActiveImage() {
    return slides[currentIndex]?.querySelector('.modal-image');
  }

  function clampTranslate(value, scaleValue, frameSize) {
    const limit = ((scaleValue - 1) * frameSize) / 2;
    if (limit <= 0) return 0;
    return Math.max(-limit, Math.min(limit, value));
  }

  function applyImageTransform() {
    const frame = getActiveFrame();
    const image = getActiveImage();
    if (!frame || !image) return;

    const rect = frame.getBoundingClientRect();
    translateX = clampTranslate(translateX, scale, rect.width);
    translateY = clampTranslate(translateY, scale, rect.height);
    image.style.transform = `translate(${translateX}px, ${translateY}px) scale(${scale})`;
    frame.classList.toggle('is-zoomed', scale > 1);
  }

  function resetImageTransform() {
    scale = 1;
    translateX = 0;
    translateY = 0;
    lastTranslateX = 0;
    lastTranslateY = 0;
    frames.forEach((frame) => frame.classList.remove('is-dragging'));
    activeDragFrame = null;
    isTouchPanning = false;
    applyImageTransform();
  }

  function showImage(index) {
    if (index >= slides.length) index = 0;
    if (index < 0) index = slides.length - 1;

    slides.forEach((slide, slideIndex) => {
      slide.classList.toggle('active', slideIndex === index);
    });

    thumbs.forEach((thumb, thumbIndex) => {
      thumb.classList.toggle('active', thumbIndex === index);
      if (thumbIndex === index) {
        thumb.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
      }
    });

    currentIndex = index;
    resetImageTransform();
    window.requestAnimationFrame(() => {
      resetImageTransform();
    });
  }

  function openViewer(index) {
    modal.style.display = 'flex';
    document.body.style.overflow = 'hidden';
    showImage(index);
  }

  function closeViewer() {
    modal.style.display = 'none';
    document.body.style.overflow = '';
    resetImageTransform();
  }

  function stepZoom(nextScale, clientX, clientY) {
    const frame = getActiveFrame();
    const image = getActiveImage();
    if (!frame || !image) return;

    const rect = frame.getBoundingClientRect();
    const boundedScale = Math.max(1, Math.min(4, nextScale));

    if (boundedScale === 1) {
      resetImageTransform();
      return;
    }

    if (typeof clientX === 'number' && typeof clientY === 'number') {
      const offsetX = clientX - rect.left - rect.width / 2;
      const offsetY = clientY - rect.top - rect.height / 2;
      const scaleRatio = boundedScale / scale;
      translateX = (translateX - offsetX) * scaleRatio + offsetX;
      translateY = (translateY - offsetY) * scaleRatio + offsetY;
    }

    scale = boundedScale;
    lastTranslateX = translateX;
    lastTranslateY = translateY;
    applyImageTransform();
  }

  function nextImage() {
    showImage(currentIndex + 1);
  }

  function prevImage() {
    showImage(currentIndex - 1);
  }

  function getDistance(touches) {
    const dx = touches[0].clientX - touches[1].clientX;
    const dy = touches[0].clientY - touches[1].clientY;
    return Math.hypot(dx, dy);
  }

  function isViewerControlTarget(target) {
    return Boolean(
      target.closest('.close') ||
      target.closest('.modal-thumb')
    );
  }

  if (allPhotosBtn) {
    allPhotosBtn.addEventListener('click', (event) => {
      event.preventDefault();
      openViewer(0);
    });
  }

  openButtons.forEach((button) => {
    button.addEventListener('click', (event) => {
      event.preventDefault();
      event.stopPropagation();
      openViewer(Number(button.dataset.imageIndex || 0));
    });
  });

  //document.querySelectorAll('.js-product-zoom-frame').forEach((frame) => {
    //frame.addEventListener('click', (event) => {
      //if (event.target.closest('.js-open-product-viewer')) return;
     // openViewer(Number(frame.dataset.imageIndex || 0));
    //});
  //});

  closeBtn.addEventListener('click', closeViewer);
  prevArrow.addEventListener('click', prevImage);
  nextArrow.addEventListener('click', nextImage);

  thumbs.forEach((thumb, index) => {
    thumb.addEventListener('click', () => {
      showImage(index);
    });
  });

  modal.addEventListener('click', (event) => {
    if (event.target === modal) {
      closeViewer();
    }
  });

  document.addEventListener('keydown', (event) => {
    if (modal.style.display !== 'flex') return;

    if (event.key === 'Escape') {
      closeViewer();
    } else if (event.key === 'ArrowLeft') {
      prevImage();
    } else if (event.key === 'ArrowRight') {
      nextImage();
    } else if (event.key === '+' || event.key === '=') {
      stepZoom(scale + 0.3);
    } else if (event.key === '-') {
      stepZoom(scale - 0.3);
    }
  });

  modalContent.addEventListener('touchstart', (event) => {
    if (modal.style.display !== 'flex' || !getActiveFrame()) return;
    if (isViewerControlTarget(event.target)) return;

    if (event.touches.length === 2) {
      isTouchPanning = false;
      pinchDistance = getDistance(event.touches);
      pinchScaleStart = scale;
      return;
    }

    if (event.touches.length === 1) {
      swipeStartX = event.touches[0].clientX;
      swipeStartY = event.touches[0].clientY;

      if (scale > 1) {
        isTouchPanning = true;
        touchPanStartX = event.touches[0].clientX;
        touchPanStartY = event.touches[0].clientY;
        touchPanBaseX = translateX;
        touchPanBaseY = translateY;
      } else {
        isTouchPanning = false;
      }
    }
  }, { passive: true });

  modalContent.addEventListener('touchmove', (event) => {
    if (modal.style.display !== 'flex' || !getActiveFrame()) return;

    if (event.touches.length === 2) {
      event.preventDefault();
      isTouchPanning = false;
      const nextDistance = getDistance(event.touches);
      const ratio = nextDistance / Math.max(pinchDistance, 1);
      stepZoom(pinchScaleStart * ratio);
      return;
    }

    if (event.touches.length === 1 && scale > 1 && isTouchPanning) {
      event.preventDefault();
      translateX = touchPanBaseX + (event.touches[0].clientX - touchPanStartX);
      translateY = touchPanBaseY + (event.touches[0].clientY - touchPanStartY);
      lastTranslateX = translateX;
      lastTranslateY = translateY;
      applyImageTransform();
    }
  }, { passive: false });

  modalContent.addEventListener('touchend', (event) => {
    if (modal.style.display !== 'flex') return;

    if (event.touches.length === 0) {
      isTouchPanning = false;
    }

    if (event.changedTouches.length === 1 && scale === 1) {
      const deltaX = event.changedTouches[0].clientX - swipeStartX;
      const deltaY = event.changedTouches[0].clientY - swipeStartY;
      if (Math.abs(deltaX) > 50 && Math.abs(deltaY) < 40) {
        if (deltaX > 0) {
          prevImage();
        } else {
          nextImage();
        }
      }
    }
  });

  window.addEventListener('wheel', (event) => {
    const activeFrame = getActiveFrame();
    if (modal.style.display !== 'flex' || !activeFrame) return;
    if (!modal.contains(event.target) || isViewerControlTarget(event.target)) return;
    event.preventDefault();
    stepZoom(scale + (event.deltaY < 0 ? 0.25 : -0.25), event.clientX, event.clientY);
  }, { passive: false });

  window.addEventListener('mousedown', (event) => {
    const activeFrame = getActiveFrame();
    if (modal.style.display !== 'flex' || scale <= 1 || event.button !== 0 || !activeFrame) return;
    if (!modal.contains(event.target) || isViewerControlTarget(event.target)) return;
    event.preventDefault();
    isDragging = true;
    activeDragFrame = activeFrame;
    pointerStartX = event.clientX;
    pointerStartY = event.clientY;
    lastTranslateX = translateX;
    lastTranslateY = translateY;
    activeFrame.classList.add('is-dragging');
  });

  window.addEventListener('mousemove', (event) => {
    if (!isDragging || scale <= 1 || !activeDragFrame) return;
    event.preventDefault();
    translateX = lastTranslateX + (event.clientX - pointerStartX);
    translateY = lastTranslateY + (event.clientY - pointerStartY);
    applyImageTransform();
  });

  window.addEventListener('mouseup', () => {
    if (!isDragging) return;
    isDragging = false;
    if (activeDragFrame) {
      activeDragFrame.classList.remove('is-dragging');
    }
    activeDragFrame = null;
    lastTranslateX = translateX;
    lastTranslateY = translateY;
  });
}

document.addEventListener('DOMContentLoaded', () => {
  initializeProductViewer();
});

document.addEventListener('DOMContentLoaded', () => {
  const sizePopup = document.querySelector('[data-complementary-size-popup]');
  const sizeForm = sizePopup?.querySelector('[data-complementary-size-form]');
  const sizeInput = sizePopup?.querySelector('[data-complementary-size-input]');
  const sizeClose = sizePopup?.querySelector('[data-complementary-size-close]');
  const discountPopup = document.querySelector('[data-complementary-discount-popup]');
  const discountPopupMessage = discountPopup?.querySelector('[data-complementary-discount-message]');
  const discountPopupClose = discountPopup?.querySelector('[data-complementary-discount-close]');
  let pendingComplementaryButton = null;
  let pendingDiscountButton = null;

  const closeComplementarySizePopup = () => {
    if (!sizePopup) return;
    sizePopup.hidden = true;
    pendingComplementaryButton = null;
  };

  const openComplementarySizePopup = (button) => {
    if (!sizePopup || !sizeInput) return;
    pendingComplementaryButton = button;
    sizeInput.value = '';
    sizePopup.hidden = false;
    sizeInput.focus();
  };

  const closeComplementaryDiscountPopup = () => {
    if (discountPopup) discountPopup.hidden = true;
    const button = pendingDiscountButton;
    pendingDiscountButton = null;
    if (button && !button.disabled) openComplementarySizePopup(button);
  };

  const canAddComplementaryProduct = async (button) => {
    if (!button.hasAttribute('data-complementary-discount-required')) return true;

    try {
      const response = await fetch('/cart.js');
      if (!response.ok) throw new Error();
      const cart = await response.json();
      const mainProductIsInCart = cart.items.some((item) => String(item.product_id) === button.dataset.mainProductId);
      if (mainProductIsInCart) return true;

      if (discountPopup && discountPopupMessage) {
        pendingDiscountButton = button;
        discountPopupMessage.textContent = `Щоб застосувалася знижка ${button.dataset.discountAmount}%, потрібно також додати до кошика «${button.dataset.mainProductTitle}».`;
        discountPopup.hidden = false;
        return false;
      }
      return true;
    } catch (error) {
      if (discountPopup && discountPopupMessage) {
        pendingDiscountButton = button;
        discountPopupMessage.textContent = 'Не вдалося перевірити корзину. Спробуйте ще раз.';
        discountPopup.hidden = false;
        return false;
      }
      return true;
    }
  };

  const addComplementaryProduct = async (button, sizeProperty) => {
    button.disabled = true;
    try {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {'Content-Type': 'application/json', 'Accept': 'application/json'},
        body: JSON.stringify({
          items: [{
            id: Number(button.dataset.variantId),
            quantity: 1,
            properties: {
              'My Size': sizeProperty
            }
          }]
        })
      });
      if (!response.ok) throw new Error();

      if (window.ShopifyCart?.updateCartCount) {
        window.ShopifyCart.updateCartCount();
      } else {
        const cartResponse = await fetch('/cart.js');
        const cart = await cartResponse.json();
        document.querySelectorAll('.cart-count').forEach((element) => {
          element.textContent = cart.item_count || 0;
        });
      }

      if (window.ShopifyCart?.loadCart) {
        window.ShopifyCart.loadCart();
      }

      button.textContent = 'added';
    } catch(error) {
      button.disabled = false;
      button.textContent = 'retry';
    }
  };

  sizeClose?.addEventListener('click', closeComplementarySizePopup);
  sizePopup?.addEventListener('click', (event) => {
    if (event.target === sizePopup) closeComplementarySizePopup();
  });
  discountPopupClose?.addEventListener('click', closeComplementaryDiscountPopup);
  discountPopup?.addEventListener('click', (event) => {
    if (event.target === discountPopup) closeComplementaryDiscountPopup();
  });
  sizeForm?.addEventListener('submit', async (event) => {
    event.preventDefault();
    if (!pendingComplementaryButton || !sizeInput) return;

    const sizeProperty = sizeInput.value.trim();
    if (!sizeProperty) {
      sizeInput.focus();
      sizeInput.reportValidity();
      return;
    }

    const button = pendingComplementaryButton;
    closeComplementarySizePopup();
    await addComplementaryProduct(button, sizeProperty);
  });

  const resizeProductWrap = () => {
    const wrap = document.querySelector('.main-product-wrap');
    const info = wrap?.querySelector('.es-product-info');
    const army = document.getElementById('army');
    if (!wrap || !info || window.innerWidth <= 880) {
      if (wrap) wrap.style.minHeight = '';
      if (army) army.style.marginTop = '';
      return;
    }

    if (army) army.style.marginTop = '';

    const wrapTop = wrap.getBoundingClientRect().top + window.scrollY;
    const infoBottom = info.getBoundingClientRect().bottom + window.scrollY;
    wrap.style.minHeight = `${Math.ceil(infoBottom - wrapTop + 60)}px`;

    if (army) {
      const armyTop = army.getBoundingClientRect().top + window.scrollY;
      const overlap = infoBottom + 60 - armyTop;
      if (overlap > 0) {
        army.style.marginTop = `${Math.ceil(overlap)}px`;
      }
    }
  };

  document.querySelectorAll('[data-complementary-products]').forEach((root) => {
    const track = root.querySelector('.es-complementary-products__track');
    if (!track) return;
    const updateNavigationVisibility = () => {
      const navigation = root.querySelector('.es-complementary-products__navigation');
      if (!navigation) return;

      const visibleItems = window.innerWidth <= 768 ? 2 : 4;
      const itemsCount = track.querySelectorAll('.es-complementary-product').length;
      navigation.hidden = itemsCount <= visibleItems;
    };
    const step = () => track.clientWidth / (window.innerWidth <= 768 ? 2 : 4);
    root.querySelector('[data-complementary-prev]').addEventListener('click', () => track.scrollBy({left:-step(), behavior:'smooth'}));
    root.querySelector('[data-complementary-next]').addEventListener('click', () => track.scrollBy({left:step(), behavior:'smooth'}));
    root.querySelectorAll('[data-complementary-variant]').forEach((select) => select.addEventListener('change', () => { select.closest('[data-complementary-card]').querySelector('[data-complementary-add]').dataset.variantId = select.value; }));
    root.querySelectorAll('[data-complementary-add]').forEach((button) => button.addEventListener('click', async () => {
      if (await canAddComplementaryProduct(button)) openComplementarySizePopup(button);
    }));
    updateNavigationVisibility();
    window.addEventListener('resize', updateNavigationVisibility);
  });
  const scheduleProductWrapResize = () => {
    requestAnimationFrame(resizeProductWrap);
    setTimeout(resizeProductWrap, 300);
    setTimeout(resizeProductWrap, 1000);
  };

  scheduleProductWrapResize();
  window.addEventListener('load', scheduleProductWrapResize);
  window.addEventListener('resize', resizeProductWrap);

  if (window.ResizeObserver) {
    const wrap = document.querySelector('.main-product-wrap');
    const info = wrap?.querySelector('.es-product-info');
    if (info) {
      new ResizeObserver(scheduleProductWrapResize).observe(info);
    }
  }
});




// Підключення Swiper JS
document.addEventListener('DOMContentLoaded', () => {
  // Ініціалізація Product Swiper
  const productSwiper = new Swiper('.product-swiper', {
    slidesPerView: 1,
    spaceBetween: 20,
    loop: false,
    centeredSlides: true,

    // Навігація стрілками
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },

    // Пагінація
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
      dynamicBullets: true,
    },

    // Свайп на мобільних
    touchRatio: 1,
    touchAngle: 45,

    // Клавіатура
    keyboard: {
      enabled: true,
      onlyInViewport: true,
    },

    // Автоплей (опціонально)
    // autoplay: {
    //   delay: 3000,
    //   disableOnInteraction: false,
    // },

    // Ефект переходу
    effect: 'slide', // або 'fade', 'cube', 'coverflow', 'flip'
    speed: 600,

    // Брейкпоінти для адаптивності
    breakpoints: {
      320: {
        slidesPerView: 1,
        spaceBetween: 10
      },
      768: {
        slidesPerView: 1,
        spaceBetween: 20
      },
      1024: {
        slidesPerView: 1,
        spaceBetween: 30
      }
    }
  });

});

  } catch(e) { console.error(e); }
})();
})();
